module.exports = __webpack_public_path__ + "media/images/svg/jobs/presentation-c88e6942e90adf1b05d577caa8da1201.svg";